import React from "react"
import * as logos from "assets/css/logos.module.css"
import { graphql, useStaticQuery } from "gatsby"

const query = graphql`
    query {
        companies: allStrapiCompany(filter: {shortname: {nin: ["Dummy", "WNS"]}}) {
            edges {
                node {
                    name
                    company_logo {
                        publicURL
                    }
                    company_logo_icon {
                        publicURL
                    }
                    website
                }
            }
        }
        strapiPage(slug: { eq: "our-companies" }) {
            title
            menu_title
            description
            Metadata {
                title
                description
            }
            category {
                name
                slug
            }
            content {
                Single_Column {
                    Text_Alignment
                    content
                    id
                    title
                }
                Multi_Columns {
                    Text_Alignment
                    content
                    id
                    title
                }
                Text_With_Image {
                    Layout_Type
                    content
                    title
                    image {
                        childImageSharp {
                            gatsbyImageData(
                                placeholder: DOMINANT_COLOR
                                backgroundColor: "#f2f2f2"
                            )
                            original {
                                width
                            }
                        }
                    }
                }
            }
        }
    }
`
const CompanyLogos = () => {
    const dataCompanies = useStaticQuery(query)

    const data = dataCompanies.companies.edges
    return (
        <div className={logos.companyLogos}>
            {data.length > 0
                ? data.map((obj, key) => {
                      const { node } = obj
                      let company_icon =
                          node.company_logo_icon &&
                          node.company_logo_icon.publicURL
                      let company_logo =
                          node.company_logo && node.company_logo.publicURL

                      return (
                          <div className={logos.companyCard} key={key}>
                              <a
                                  className={logos.companyLogo}
                                  href={node.website}
                                  target="_blank"
                                  rel="noreferrer"
                              >
                                  <img
                                      src={company_icon || company_logo}
                                      alt={node.name}
                                      width="100"
                                      height="99"
                                  />
                              </a>
                          </div>
                      )
                  })
                : null}
        </div>
    )
}

export default CompanyLogos
